<template>
  <div class="container py-6 user-agreement" v-html="$t('user_aggrement')"></div>
</template>

<script>
export default {

}
</script>

<style lang="sass" scoped>
@import "src/assets/styles-new/typography"
@import "src/assets/styles-new/vars"

.tt-public-offer
  padding: 40px 0 100px
  &__title
    font-size: $fs-larger
    line-height: 1.2em
    font-weight: $fw-semibold
    margin-bottom: 48px

@media screen and (max-width: $tablet-width)
  .tt-public-offer
    padding: 40px 0
    &__title
      font-size: $fs-large

@media screen and (max-width: $mobile-width)
  .tt-public-offer
    padding-top: 16px
    &__title
      font-size: $fs-semilarge
      margin-bottom: 32px

::v-deep .legacy-block__content
  ol
    list-style: none
    padding-left: 0
    margin: 0

.user-agreement
    padding-bottom: 80px
    padding-top: 80px
</style>